<template>
  <div class="adress__body adress__pickup-list">
    <label v-for="address in addresses" class="adress__pickup-radio">
      <input @change="$emit('mapMyAddress',  {custom_field: { address: address.custom_field } })"  :value="address.address_id" v-model="address_id" type="radio" name="institution_id">
      <div class="adress__pickup-label">
        <div class="adress__pickup-left">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="adress__pickup-right">
          <div class="adress__pickup-title">{{ address.custom_field['8'] }}</div>
          <div class="adress__pickup-time">
            <span v-if="address?.custom_field?.[1]">дом: {{ address?.custom_field?.[1] }};&nbsp;</span>
            <span v-if="address?.custom_field?.[4]">подъезд: {{ address?.custom_field?.[4] }};&nbsp;</span>
            <span v-if="address?.custom_field?.[2]">этаж: {{ address?.custom_field?.[2] }};&nbsp;</span>
            <span v-if="address?.custom_field?.[3]">квартира: {{ address?.custom_field?.[3] }};&nbsp;</span>
            <span v-if="address?.custom_field?.[16]">частный дом</span>
          </div>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ThePickupMap from "@/components/element/order/shipping/ThePickupMap.vue";
import AddressBookSource from "@/api/AddressBookSource.js";
export default {
  name: 'TheShippingMyAdresss',
  components: {ThePickupMap},
  props: {
    showMap: {
      default: true
    },
  },
  data() {
    return {
      isLoading: false,
      address_id: false,
      addresses: false,
    }
  },
  computed: {
    ...mapState({
      currentCity: state => state.city.currentCity,
    })
  },
  mounted() {
    this.load()
  },
  methods:{
    async load() {
      this.isLoading = true;
      try {
        await this.$API.manager.getSource(AddressBookSource).addresses({}).then((response) => {
          this.addresses = response.list.filter(({ custom_field }) => String(custom_field[14]) === String(this.currentCity.store_id))
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>